import styled from 'styled-components';
import { colors, toRgba, mixins } from '@/styles';

export const RowDetails = styled.div<{}>`
  overflow: auto;
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  box-shadow: 0 0 20px 0px ${toRgba(colors.primary.black, 0.15)};
  background: ${colors.secondary.lightGray1};

  pre {
    font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
      sans-serif;
    font-feature-settings: 'tnum';
    font-variant-numeric: tabular-nums;
  }
`;

export const Body = styled.div<{}>`
  padding: 10px;
`;

export const RowDetailsPlaceholder = styled.div<{}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100%;
  width: 100%;
`;

export const RowNavigation = styled.div<{}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;
